import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("si_"), S.String).pipe(S.annotations({
    identifier: "@open-revenue/schema/stripe/SubscriptionItemId",
    description: "The id of the subscription item in Stripe",
    examples: [
        "si_1234567890"
    ]
}));
export const make = (subscriptionItemId)=>S.decodeUnknown(Schema)(subscriptionItemId);
export const makeUnsafe = (subscriptionItemId)=>subscriptionItemId;
